<template>
  <div>
    <div class="web5">
      <div class="outterBox">
        <div class="topHeader">
          <span class="headerText">안내사항</span>
        </div>
        <div class="top">
          <table v-if="myMemTypeBubinPkg && listType === 'RECEIPT'" class="bordered tableStyle">
            <tbody>
              <tr>
                <td width="20%" class="text-center"><span class="infoHeader">사전 접수</span></td>
                <td class="">
                  <p>8주 전 목요일 9시부터 17시까지 접수</p>
                  <p>※ 주 단위로 오픈</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">예약 배정</span></td>
                <td class="">
                  <p>우선 배정 원칙에 의함</p>
                  <p>※ 우선배정 원칙은 예약 배정이 오래된 순, 본인 배정 횟수가 적은 순 우선 배정</p>
                  <p>※ 잦은 취소, No-show, 내장자 불일치 등의 위약 사항 또한 반영</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">예약 확인 및 안내</span></td>
                <td class="">
                  <p class="mb-0">7주 전 화요일 13시 예약 결과 홈페이지 확인 / SMS 발송</p>
                  <p class="mb-0">- 마이페이지>예약정보관리>예약확정 內 확인 가능</p>
                  <p class="mb-0">- 예약 접수 시 SMS수신 체크 된 휴대폰으로 알림톡 / SMS 전송</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">확정예약 및 접수내역 취소</span></td>
                <td class="">
                  <p class="mb-0">마이페이지 內 취소 가능</p>
                  <p class="mb-0">
                    - 확정 예약은 내장일로부터 7일 전까지 무료 취소 가능하며, 6일 이내 취소 시 취소 사유에 따라 패널티
                    부과
                  </p>
                  <p class="mb-0">※ 기상악화, 코로나 이슈 등으로 인한 취소는 별도 문의 要</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">휴장 일정 안내</span></td>
                <td class="">
                  <p class="mb-0 text-danger font-weight-bold">매 월 3번째 수요일 정기 휴장</p>
                  <p class="mb-0">※ 골프장 운영 상황에 따라 변동될 수 있음</p>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else-if="myMemTypeBubinPkg && listType === 'WAIT'" class="bordered tableStyle">
            <tbody>
              <tr>
                <td width="20%" class="text-center"><span class="infoHeader">잔여 접수</span></td>
                <td class="">
                  <p class="mb-0">7주 전 화요일 13시부터 내장일 2일 전 17시까지 접수 가능</p>
                  <p class="mb-0">(홈페이지 접수 불가한 임박한 일정은 유선 문의 바랍니다)</p>
                  <p class="mb-0">(예)</p>
                  <p class="mb-0">1/1(일) 17시 이전 → 1/3(화) 내장부터 접수 가능</p>
                  <p class="mb-0">1/1(일) 17시 이후 → 1/4(수) 내장부터 접수 가능</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">접수 배정 기준</span></td>
                <td class="">
                  <p class="mb-0">접수 선착순 배정 (잔여 타임 限)</p>
                  <p class="mb-0">
                    ※접수가 가능하더라도 확정 예약은 아니며, 접수 순서 및 잔여 타임 수에 의해 확정이 어려울 수 있습니다.
                  </p>
                  <p class="mb-0">
                    ※선착순 배정 원칙으로, 접수 내역 취소 후 재 접수 시 접수 순번은 초기화됩니다. (후순위로 변경)
                  </p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">골프 배정 확인</span></td>
                <td class="">
                  <p class="mb-0">- 마이페이지>예약정보관리>예약확정에서 배정 여부 확인 가능합니다.</p>
                  <p class="mb-0">- 예약 접수 시 SMS 수신체크된 휴대폰으로 확정 여부 알림톡/SMS 발송됩니다.</p>
                  <p class="mb-0">- 마감 건은 본인 내장 건에 한해 마이페이지에서 대기 접수 가능합니다.</p>
                  <p class="mb-0">※ 대기 접수 신청을 안 할 경우 잔여 시간이 나와도 별도의 연락을 드리지 않습니다</p>
                  <p class="mb-0">※ 배우자/추천 내장은 대기 접수 불가합니다.</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">대기 접수</span></td>
                <td class="">
                  <p class="mb-0">
                    마감된 일자 대기 접수 신청 시, 마이페이지>예약정보관리>대기접수에서 대기 일정 확인 가능합니다.
                  </p>
                  <p class="mb-0">
                    ※ 배정이 보장된 접수는 아니며, 잔여 시간이 있을 경우 신청자에게로 개별 연락 드립니다.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else class="bordered tableStyle">
            <tbody>
              <tr>
                <td width="20%" class="text-center"><span class="infoHeader">잔여 접수</span></td>
                <td>
                  <p class="mb-0">7주 전 월요일 13시부터 내장일 2일 전 17시까지 접수 가능</p>
                  <p class="mb-0">(홈페이지 접수 불가한 임박한 일정은 유선 문의 바랍니다)</p>
                  <p class="mb-0">(예)</p>
                  <p class="mb-0">1/1(일) 17시 이전 → 1/3(화) 내장부터 접수 가능</p>
                  <p class="mb-0">1/1(일) 17시 이후 → 1/4(수) 내장부터 접수 가능</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">접수 배정 기준</span></td>
                <td class="">
                  <p class="mb-0">접수 선착순 배정 (잔여 타임 限)</p>
                  <p class="mb-0">
                    ※ 접수가 가능하더라도 확정 예약은 아니며, 접수 순서 및 잔여 타임수에 의해 확정이 어려울 수 있습니다
                  </p>
                  <p class="mb-0">
                    ※ 선착순 배정 원칙으로, 접수 내역 취소 후 재 접수 시 접수 순번은 초기화 됩니다 (후순위로 변경)
                  </p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">골프 배정 확인</span></td>
                <td class="">
                  <p class="mb-0">-마이페이지>예약정보관리>예약확정 內 배정 여부 확인 가능합니다</p>
                  <p class="mb-0">-예약 접수 시 SMS수신 체크하실 경우 확정 여부 알림톡/SMS 발송됩니다.</p>
                  <p class="mb-0">-마감 건은 마이페이지에서 대기 접수 가능합니다.</p>
                </td>
              </tr>
              <tr>
                <td class="text-center"><span class="infoHeader">대기 접수</span></td>
                <td class="">
                  <p class="mb-0">
                    마감된 일자 대기 접수 신청 시, 마이페이지>예약정보관리>대기접수에서 대기 일정 확인 가능합니다.
                  </p>
                  <p class="mb-0">
                    ※배정이 보장된 접수는 아니며, 잔여 시간이 있을 경우 신청자에게로 개별 연락 드립니다.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceiptInfo',
  props: {
    listType: String,
  },
  computed: {
    myMemTypeBubinPkg() {
      return this.selectedMember.memType === '006';
    },
    selectedMember() {
      return this.$store.getters['Auth/selectedMember'];
    },
  },
};
</script>

<style scoped lang="scss">
.tableStyle {
  width: 100%;
}

// 데스크탑 분기
@media (min-width: 992px) {
  .outterBox {
    .topHeader {
      padding-top: 1rem;
      padding-left: 2rem;

      font-weight: bold;
      font-size: 1.3rem;
    }

    .top {
      display: flex;
      padding: 1rem 1.2rem;
    }
  }
  td {
    font-size: 0.9rem;
    border-bottom: 1px solid #e3e3e3;
    display: table-cell;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 0rem;
    padding-right: 0rem;
    word-break: keep-all;

    line-height: 2rem;
    vertical-align: middle;
    p {
      margin: 0px;
    }
  }
  ol.rounded-list {
    //  counter-reset: li;
    //  list-style: none;
    padding: 0;
  }
  span {
    text-align: center;
    font-weight: bold;
  }
  .infoDetail {
    position: relative;
    display: block;
    height: 1.5em;
    line-height: 2.5rem;
    letter-spacing: -0.02rem;
    font-size: 0.9rem;
  }
}

// 모바일 분기
@media (max-width: 992px) {
  hr {
    margin: 0px;
  }

  .outterBox {
    .topHeader {
      padding-top: 2rem;
      padding-left: 1rem;

      font-weight: bold;
      font-size: 1.3rem;
    }
    .top {
      display: flex;
      padding: 1rem 1.2rem;
    }
  }
  td {
    font-size: 0.8rem;
    border-bottom: 1px solid #e3e3e3;
    display: table-cell;

    line-height: 1.2rem;
    vertical-align: middle;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0rem;
    padding-right: 0rem;
    word-break: keep-all;
    p {
      font-size: 0.7rem;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      margin-left: 0.2rem;
      margin-right: 0.2rem;
    }
  }
  ol.rounded-list {
    //  counter-reset: li;
    //  list-style: none;
    padding: 0;
  }
  span {
    text-align: center;
    font-weight: bold;
  }
  .infoDetail {
    position: relative;
    display: block;
    height: 1.5em;
    line-height: 2.5rem;
    letter-spacing: -0.02rem;
    font-size: 0.7rem;
  }

  .infoHeader {
    font-size: 0.7rem;
  }
}
</style>
